import React from 'react'
import * as UI from 'ui'
import { SpaceBetween } from 'ui'
import * as Displays from 'support/displays'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { Model, WhenModelValue } from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import ValueAdjustedCircle from 'widgets/economy/partials/ValueAdjustedCircle'
import CookieFilter from "support/filters/CookieFilter";

export default function FoodsToDrinksRatioEconomyWidget () {
  return (
    <Widget>
      <Translator namespace='economy.food_to_drink_ratio'>
        <UI.Card paddingBottom={false}>
          <SpaceBetween>
            <UI.Text weight='medium' size='lg'>
              <Translation name='title' />
            </UI.Text>
          </SpaceBetween>

          <Model resourceName='economy' operationName='food_to_drink_ratio'>
            <CookieFilter name='period' cookieKey='page.filters.period' />
            <SelectedDepartmentFilter />

            <div className='w-full flex justify-center relative py-6'>
              <div className='h-36 w-36 relative'>

                <ValueAdjustedCircle name='food_ratio' defaultValue={0.5} className='absolute left-2 top-2 border-primary-500'>
                  <UI.Text weight='medium' size='base' align='right' color='black'>
                    <Displays.Percentage name='food_ratio' decimals={0} />
                  </UI.Text>
                </ValueAdjustedCircle>

                <ValueAdjustedCircle name='drink_ratio' defaultValue={0.5} className='absolute right-2 bottom-2 border-primary-200'>
                  <UI.Text weight='medium' size='base' align='right' color='black'>
                    <Displays.Percentage name='drink_ratio' decimals={0} />
                  </UI.Text>
                </ValueAdjustedCircle>

              </div>
            </div>

            <div className='flex flex-col flex-grow flex-shrink'>

              <UI.SpaceBetween>
                <UI.Text size='base'>
                  <Translation name='food_ratio' />
                </UI.Text>
                <UI.Text weight='medium' size='base' align='right' color='black'>
                  <Displays.Currency name='food_count' decimals={0} />
                </UI.Text>
              </UI.SpaceBetween>

              <SmartviewContentSeparator className='my-4' />

              <UI.SpaceBetween>
                <UI.Text size='base'>
                  <Translation name='drink_ratio' />
                </UI.Text>
                <UI.Text weight='medium' size='base' align='right' color='black'>
                  <Displays.Currency name='drink_count' decimals={0} />
                </UI.Text>
              </UI.SpaceBetween>

            </div>

            <UI.HorizontalList justify='start' className='mt-6 mb-4'>
              <UI.WithSubtitle
                subtitle={(
                  <UI.Text weight='medium' color='black'>
                    <Displays.Percentage
                      showPlusIfPositive
                      decimals={1}
                      name='previous_period_food_ratio'
                    />
                    <span> / </span>
                    <Displays.Percentage
                      showPlusIfPositive
                      decimals={1}
                      name='previous_period_drink_ratio'
                    />
                  </UI.Text>
                )}
              >
                <UI.Text uppercase size='xs' color='gray'>
                  <Translation name='generic.last_year' />
                </UI.Text>
              </UI.WithSubtitle>

            </UI.HorizontalList>
          </Model>

        </UI.Card>
      </Translator>
    </Widget>
  )
}
